const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
const DataTable = require('components/charts/DataTable/DataTable');
const DataTableColumn = require('components/charts/DataTableColumn/DataTableColumn');
const PercentageBar = require('components/commons/PercentageBar');
const { formatValue } = require('../utilities/valueFormater');

const valueToFundSize = v =>
    [
        formatText('fundsCard-extraLargeCapital'),
        formatText('fundsCard-largeCapital'),
        formatText('fundsCard-midCapital'),
        formatText('fundsCard-smallCapital'),
        formatText('fundsCard-extraSmallCapital'),
    ][Number(v) - 1];

const MarketCapitalBreakdownTable = ({ data }) => (
    <DataTable data={data}>
        <DataTableColumn
            dataKey="type"
            header={formatText('fundsCard-size').toUpperCase()}
            format={valueToFundSize}
        />
        <DataTableColumn
            dataKey="net"
            header={formatText('fundsCard-percentage').toUpperCase()}
            format={v => `${formatValue(v)}%`}
        />
        <DataTableColumn
            dataKey="net"
            format={v => <PercentageBar percentage={v} />}
        />
    </DataTable>
);

MarketCapitalBreakdownTable.propTypes = {
    data: PropTypes.array.isRequired,
};

module.exports = MarketCapitalBreakdownTable;
